import { Flex } from '@chakra-ui/react'
import debounce from 'lodash/debounce'
import React, { useEffect, useRef, useState } from 'react'

import { IMessagesProps, IShortMessageObject } from '@/types/gigiChat/Chat'

import Message from './Message'
import MessagesSkeleton from './messagesSkeleton'
import TextExamples from './textExamples'

const Messages = ({ messages, shouldDisplay, settings, onNewQuestion }: IMessagesProps) => {
    const canScroll = !(sessionStorage.getItem('canScroll') && sessionStorage.getItem('canScroll') === '0')
    const [isUserScrolledAway, setIsUserScrolledAway] = useState<boolean>(false)
    const scrollContainerRef = useRef<HTMLDivElement | null>(null)
    const scrollTargetRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        if (scrollTargetRef?.current && canScroll && !isUserScrolledAway) {
            // smooth scroll is *usually* a better ux, but triggers many more scroll events
            // with the debounced handler the excess events seem to not matter though
            scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    })

    const handleScroll = debounce<React.UIEventHandler<HTMLDivElement>>(() => {
        const t = scrollContainerRef.current
        if (t) {
            const maxScroll = t.scrollHeight - t.clientHeight
            // 100px threshold to disable auto scroll isn't based on anything except trial and error, seems to work well
            const withinThreshold = t.scrollTop > maxScroll - 100
            setIsUserScrolledAway(() => !withinThreshold)
        }
        // one frame-ish wait is pretty arbitrary here but seems to work well enough
    }, 16)

    const shouldDisplayTextExamples = () => {
        if (Array.isArray(messages)) {
            const elementCondition = messages.some((item) => item.question !== null)

            return !elementCondition
        }

        return false
    }

    if (!messages || messages.length === 0) {
        return <MessagesSkeleton />
    }

    return (
        <Flex
            ref={scrollContainerRef}
            w="100%"
            height="85%"
            overflowY="auto"
            flexDirection="column"
            paddingTop="8px"
            paddingBottom="8px"
            marginTop="24px"
            display={shouldDisplay ? 'flex' : 'none'}
            onScroll={handleScroll}
        >
            {Array.isArray(messages) &&
                messages.map((item: IShortMessageObject, index: number) => (
                    <Message messages={messages} item={item} settings={settings} key={index} index={index} onNewQuestion={onNewQuestion} />
                ))}
            <div ref={scrollTargetRef}></div>
            {shouldDisplayTextExamples() && <TextExamples />}
        </Flex>
    )
}

export default Messages
